// extracted by mini-css-extract-plugin
export default {"voucherWrapper":"VWEyJO","voucherCard":"IhHegd","offer":"L9BoA7"};